import LegalPage from '../components/LegalPage';
import { LEGAL_INFO } from '../legalInfo';

const { companyName, website, legalEmail, jurisdiction, minimumAge } = LEGAL_INFO;

const SECTIONS = [
  {
    id: 'aceptacion',
    title: 'Aceptación de los términos',
    content: (
      <p>
        Al crear una cuenta o usar {website}, aceptas estos Términos y Condiciones y nuestra{' '}
        <a href="/privacidad/">Política de Privacidad</a>. Si no estás de acuerdo, no uses el
        servicio.
      </p>
    ),
  },
  {
    id: 'servicio',
    title: 'Descripción del servicio',
    content: (
      <>
        <p>{companyName} es una plataforma que te permite:</p>
        <ul>
          <li>Registrar compras y ventas de acciones y opciones del mercado de EE.UU.</li>
          <li>Visualizar estadísticas, gráficas y el rendimiento de tus estrategias por fecha.</li>
          <li>Compartir, de forma opcional, tus movimientos e ideas con otros usuarios.</li>
        </ul>
        <p>
          {companyName} no es un bróker: no ejecuta órdenes, no custodia fondos ni valores y
          no está conectado a tu cuenta de inversión para operar en tu nombre.
        </p>
      </>
    ),
  },
  {
    id: 'no-asesoria',
    title: 'No es asesoría financiera',
    content: (
      <>
        <p>
          <strong>
            Nada de lo publicado en {companyName} constituye asesoría financiera, de
            inversión, legal ni fiscal.
          </strong>{' '}
          Las estadísticas, gráficas y el contenido de la comunidad tienen fines informativos
          y educativos.
        </p>
        <p>
          El trading de acciones y, especialmente, de opciones implica un alto riesgo y puede
          ocasionar la pérdida total del capital invertido. Los resultados pasados no
          garantizan resultados futuros. Eres el único responsable de tus decisiones de
          inversión.
        </p>
      </>
    ),
  },
  {
    id: 'cuenta',
    title: 'Elegibilidad y cuenta',
    content: (
      <ul>
        <li>Debes tener al menos {minimumAge} años para usar el servicio.</li>
        <li>La información que proporciones al registrarte debe ser verdadera y actualizada.</li>
        <li>
          Eres responsable de mantener la confidencialidad de tu contraseña y de toda la
          actividad realizada desde tu cuenta.
        </li>
        <li>
          Debes avisarnos de inmediato si detectas un acceso no autorizado a tu cuenta.
        </li>
      </ul>
    ),
  },
  {
    id: 'contenido',
    title: 'Tu contenido',
    content: (
      <>
        <p>
          Conservas la propiedad de los datos que registras en tu bitácora y del contenido que
          publicas. Al publicar contenido en la comunidad, nos otorgas una licencia mundial, no
          exclusiva y gratuita para alojarlo, mostrarlo y distribuirlo dentro de la plataforma,
          únicamente para operar el servicio. Esta licencia termina cuando eliminas el
          contenido o tu cuenta.
        </p>
        <p>
          Eres responsable del contenido que compartes y de que sea veraz. No verificamos la
          exactitud de las operaciones o resultados publicados por otros usuarios.
        </p>
      </>
    ),
  },
  {
    id: 'conducta',
    title: 'Conducta prohibida',
    content: (
      <>
        <p>Al usar {companyName} te comprometes a no:</p>
        <ul>
          <li>
            Publicar información falsa o engañosa sobre operaciones o resultados para
            influir en otros usuarios.
          </li>
          <li>
            Promover esquemas de manipulación de mercado, como «pump and dump», o compartir
            información privilegiada.
          </li>
          <li>
            Ofrecer servicios de asesoría de inversión, señales pagadas o captar fondos sin
            las licencias requeridas.
          </li>
          <li>Acosar, amenazar, discriminar o suplantar la identidad de otras personas.</li>
          <li>Enviar spam, publicidad no autorizada o enlaces maliciosos.</li>
          <li>
            Extraer datos de forma automatizada, interferir con la plataforma o intentar
            acceder a cuentas ajenas.
          </li>
          <li>Usar el servicio para cualquier actividad ilegal.</li>
        </ul>
        <p>
          Podemos eliminar contenido o suspender cuentas que incumplan estas reglas, sin
          previo aviso.
        </p>
      </>
    ),
  },
  {
    id: 'pagos',
    title: 'Planes, pagos y cancelación',
    content: (
      <ul>
        <li>
          Algunas funciones pueden requerir un plan de pago. Los precios y características
          vigentes se muestran en la plataforma antes de contratar.
        </li>
        <li>
          Las suscripciones se renuevan automáticamente al final de cada periodo, salvo que
          las canceles antes de la fecha de renovación.
        </li>
        <li>
          Puedes cancelar en cualquier momento desde tu cuenta; conservarás el acceso hasta el
          final del periodo pagado.
        </li>
        <li>
          Salvo que la ley aplicable disponga lo contrario, los pagos realizados no son
          reembolsables.
        </li>
        <li>
          Si cambiamos los precios, te avisaremos con al menos 30 días de anticipación.
        </li>
      </ul>
    ),
  },
  {
    id: 'propiedad',
    title: 'Propiedad intelectual',
    content: (
      <p>
        La plataforma, su diseño, código, marca, logotipos y demás elementos son propiedad de{' '}
        {companyName} o de sus licenciantes. No puedes copiarlos, modificarlos ni
        distribuirlos sin autorización por escrito.
      </p>
    ),
  },
  {
    id: 'terceros',
    title: 'Datos y servicios de terceros',
    content: (
      <p>
        Los precios, cotizaciones y otros datos de mercado pueden provenir de proveedores
        externos y mostrarse con retraso o contener errores. {companyName} no garantiza su
        exactitud ni disponibilidad y no es responsable de los servicios o sitios de
        terceros enlazados desde la plataforma.
      </p>
    ),
  },
  {
    id: 'garantias',
    title: 'Exención de garantías',
    content: (
      <p>
        El servicio se proporciona «tal cual» y «según disponibilidad». No garantizamos que
        funcione sin interrupciones ni errores, ni que los cálculos y estadísticas estén
        libres de imprecisiones. Te recomendamos conservar tus propios registros, en
        especial para fines fiscales.
      </p>
    ),
  },
  {
    id: 'responsabilidad',
    title: 'Limitación de responsabilidad',
    content: (
      <p>
        En la medida máxima permitida por la ley, {companyName} no será responsable de
        pérdidas de inversión, lucro cesante, pérdida de datos ni daños indirectos derivados
        del uso o la imposibilidad de usar el servicio, o de decisiones tomadas con base en la
        información de la plataforma o de otros usuarios. Nuestra responsabilidad total no
        excederá el monto que hayas pagado en los 12 meses anteriores al reclamo.
      </p>
    ),
  },
  {
    id: 'indemnizacion',
    title: 'Indemnización',
    content: (
      <p>
        Aceptas mantener indemne a {companyName} frente a reclamos de terceros derivados del
        contenido que publiques, del uso indebido del servicio o del incumplimiento de estos
        términos.
      </p>
    ),
  },
  {
    id: 'terminacion',
    title: 'Suspensión y terminación',
    content: (
      <p>
        Puedes dejar de usar el servicio y eliminar tu cuenta en cualquier momento. Podemos
        suspender o cerrar tu cuenta si incumples estos términos o si lo exige la ley. Antes
        de cerrar una cuenta por motivos distintos a un incumplimiento, te daremos la
        oportunidad de exportar tu bitácora.
      </p>
    ),
  },
  {
    id: 'ley',
    title: 'Ley aplicable',
    content: (
      <p>
        Estos términos se rigen por las leyes de {jurisdiction}. Cualquier controversia se
        someterá a los tribunales competentes de dicha jurisdicción, sin perjuicio de los
        derechos que te otorguen las leyes de protección al consumidor de tu país de
        residencia.
      </p>
    ),
  },
  {
    id: 'cambios',
    title: 'Cambios a estos términos',
    content: (
      <p>
        Podemos modificar estos términos. Si los cambios son relevantes, te avisaremos por
        correo electrónico o en la plataforma con antelación. Si continúas usando el servicio
        después de su entrada en vigor, se entenderá que los aceptas.
      </p>
    ),
  },
  {
    id: 'contacto',
    title: 'Contacto',
    content: (
      <p>
        Para cualquier duda sobre estos términos, escríbenos a{' '}
        <a href={`mailto:${legalEmail}`}>{legalEmail}</a>.
      </p>
    ),
  },
];

function TermsPage() {
  return (
    <LegalPage
      title="Términos y Condiciones del Servicio"
      intro={`Estos términos regulan el uso de ${companyName} (${website}), la bitácora de trading para acciones y opciones del mercado de valores de EE.UU. Léelos con atención antes de usar la plataforma.`}
      sections={SECTIONS}
      related={{ href: '/privacidad/', label: 'Política de Privacidad' }}
    />
  );
}

export default TermsPage;
